import renderMenu from "./renderMenu";
import toggleMenu from "./toggleMenu";
import translateWidget from "./translateWidget";

export let $menu: HTMLElement | undefined;

export function openMenu() {
    if($menu) {
        toggleMenu();
    } else {
        $menu = renderMenu();
        const widgetContainer = document.querySelector('#cya11y-container');
        const btn = widgetContainer?.shadowRoot?.querySelector('.cya11y-menu-btn') as HTMLElement | null;
        btn?.setAttribute('aria-controls', 'cya11y-accessibility-menu');
        // First open: renderButton's own click handler re-checks this 10ms
        // after activation, but CDN core load can take 50-100ms, so the
        // button must already reflect the open state the moment the menu
        // first renders — don't wait for that re-check.
        btn?.setAttribute('aria-expanded', 'true');
    }

    translateWidget($menu);
}